import { DigitalChannelType } from '@nice-ccf/core-sdk';

const data = {
  tw_1064553226341621761: {
    id: 'tw_1064553226341621761',
    channelId: 'tw_1064553226341621761',
    originId: '1064553226341621761',
    idOnExternalPlatform: '1064553226341621761',
    type: 'tw',
    externalPlatformId: 'tw',
    realExternalPlatformId: 'tw',
    name: '@Chimerical',
    externalPlatformAvatar:
      'https://brand-embassy-channel-twitter-qa.s3.eu-west-1.amazonaws.com/1064553226341621761_7499f242-c206-4b04-b769-9130c99c6155.jpeg',
    externalPlatformIcon: 'twitter',
    integrationBoxIdent: null,
    channelIntegrationId: null,
    hasReply: true,
    hasTreeStructure: true,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: false,
    hasAbilityToQuoteMessage: true,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 0,
    hasPublishing: true,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: true,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: false,
    replyPrefixMentionTemplate: '@@{userNickname}',
    nicknameOnExternalPlatform: 'Chimerical',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-Twitter-Queue',
    messages: [
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1364919321047166982',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Check out our just-launched Widget Model Y!  It blows away the competition being 50% faster and 30% cooler than anything in the market!',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-02-25T12:44:59+0000',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110003',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: '@Chimerical',
          firstName: 'Chimerical',
          surname: 'Chimerical',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391648474915950598',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Me too. I’ve been soooo frustrated with Model X. These clowns are going to expect us to upgrade to get a fix.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T06:57:06+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Errol Sloan',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391649967689723911',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I don’t know what you’re talking about.  I got my Model X four months ago and it’s been rock-solid.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:03:02+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Jarrod Spence',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391650112724635648',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I gave up on Chimerical products.  I moved to Bellerophon last year and haven’t looked back!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:03:37+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Sue Stein',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'f3bf58ef-b7ad-4372-9ccd-060a0d618ab5',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391650229330481155',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I’ve been using X for couple years with great results.  I’ll definitely be looking into Model Y!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:04:05+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Dawn Finley',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '143b251d-c634-47f0-86ba-fa0aeb8da497',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '50% faster and 30% cooler probably means 1000% more expensive.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:17:44+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Fidel Davila',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '1952f39c-ec9f-4870-8bb4-ba5b1fc2638c',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '50% faster probably means it’s going to need to be reset 50% more often.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:18:05+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Ronda Estes',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '9f8d7d03-ed6e-4438-a890-e3095e07fb94',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'If those performance improvements are remotely accurate, I’m interested!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:21:49+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Reva Forbes',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'd2cc1b2a-037d-405a-b6aa-7d1255f53556',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I wish you would fix Widget Model X because I have to reset it at least once a month.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:29:39+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'agent',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'ace37ffe-ec99-441d-ac68-1ae45e2f0abf',
        isOwn: true,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I wish you would fix Widget Model X because I have to reset it at least once a month.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:29:39+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'agent',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'ace37ffe-ec99-441d-ac68-1ae45e2f0123',
        isOwn: true,
      },
    ],
  },
  chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d: {
    id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    channelId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    originId: 'b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    idOnExternalPlatform: 'b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    type: 'chat',
    externalPlatformId: 'chat',
    realExternalPlatformId: 'chat',
    name: 'This is my testing chat',
    externalPlatformAvatar: '',
    externalPlatformIcon: 'live-chat',
    integrationBoxIdent: '2507eb36-065b-4e41-aca9-c5a07af4803d',
    channelIntegrationId: '2507eb36-065b-4e41-aca9-c5a07af4803d',
    hasReply: true,
    hasTreeStructure: false,
    hasPostAsPlaceholder: true,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: true,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: true,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1130,
    hasPublishing: false,
    hasAbilityToSendFiles: true,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: '',
    isLiveChat: true,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-Chat-Queue',
    messages: [
      {
        id: 'chat_1359751597379620865_b81029d6-c53t-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '13649193210471634682',
        threadId:
          'chat_1359751597379620865_b81029d6-c53t-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'clarkkent@do31.com',
          loginUsername: '@Clark',
          firstName: 'Clark',
          surname: 'Kent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'chat_1359751597379620865_b81029d6-c53t-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
    ],
  },
  chatwithbotranscript_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d: {
    id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    channelId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    originId: 'b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    idOnExternalPlatform: 'b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
    type: 'chat',
    externalPlatformId: 'chat',
    realExternalPlatformId: 'chat',
    name: 'This is my testing chat',
    externalPlatformAvatar: '',
    externalPlatformIcon: 'live-chat',
    integrationBoxIdent: '2507eb36-065b-4e41-aca9-c5a07af4503d',
    channelIntegrationId: '2507eb36-065b-4e41-aca9-c5a07af4503d',
    hasReply: true,
    hasTreeStructure: false,
    hasPostAsPlaceholder: true,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: true,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: true,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1130,
    hasPublishing: false,
    hasAbilityToSendFiles: true,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: '',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-Chat-Queue',
    messages: [
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date().toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'customer.service@delta.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Hello! Welcome to OneTravel. How can I assist you today?',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 600000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: "Hi, I'm looking to book a 10-day trip to Iceland. Can you provide me with some package options?",
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 540000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'user@delta.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Sure! I can help with that. Could you please specify your travel dates?',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 480070).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: "I haven't decided on the exact dates yet, but I'm thinking sometime in June. Can you show me the available packages for June?",
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 420000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'user.service@delta.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Great choice! June is a fantastic time to visit Iceland. Let me check the available packages for you. One moment, please.',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 360000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: "I'm sorry, but it looks like I need more specific dates to provide accurate package options. Could you provide a tentative start date?",
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 300000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: "Let's say June 15th. Can you show me the options now?",
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 240000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'user.service@delta.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Thank you! I will look up the packages starting from June 15th. Just a moment, please!',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 180020).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: "I'm having trouble retrieving the package options for those dates. Let me transfer you to a human agent who can assist you further.",
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 120000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Please hold on for a moment while I connect you with an agent.',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date(new Date().getTime() - 60000).toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'bot@nice.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: true,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        messageContent: {
          type: 'DIVIDER',
          payload: {
            text: 'test data',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: new Date().toUTCString(),
        direction: 'string',
        authorUser: {
          id: 242578,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'user@delta.com',
          loginUsername: '@JPatrick',
          firstName: 'Patrick',
          surname: 'Jordan',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
    ],
  },
  email_139: {
    id: 'email_139',
    historyemail: false,
    channelId: 'email_139',
    originId: '139',
    idOnExternalPlatform: '139',
    type: 'email',
    externalPlatformId: 'email',
    realExternalPlatformId: 'email',
    name: 'Email test',
    externalPlatformAvatar: '',
    externalPlatformIcon: '',
    integrationBoxIdent: null,
    channelIntegrationId: null,
    hasReply: true,
    hasTreeStructure: true,
    hasPostAsPlaceholder: false,
    contentFormat: 'html',
    hasCustomerOnThirdParty: false,
    isPostWritable: false,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: true,
    hasAbilityToTag: false,
    ownerUserId: 0,
    hasPublishing: false,
    hasAbilityToSendFiles: true,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: false,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: '',
    isLiveChat: false,
    hasAbilityToChangeRecipient: true,
    hasMultipleRecipient: true,
    hasCcAndBcc: true,
    hasVisibleTitle: true,
    hasEditableTitle: true,
    hasVisibleRecipients: true,
    hasAbilityToForwardMessage: true,
    canSaveResponse: false,
    skill: 'KK-Email-Queue',
    messages: [
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1364919321047166982',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Delta,<br><br>In my most recent flight I checked in my bags, and one of my suitcases came back damaged. I was reading the customer guidelines about luggage handling. It looks like it is possible to be reimbursed for the damage. I would like to be compensated to replace or repair my broken luggage.<br><br>Thanks,<br>Liam</p>',
          },
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110003',
          emailAddress: 'DavisBRLiam342@sunsyst.com',
          loginUsername: 'DavisBRLiam342@sunsyst.com',
          firstName: 'Davis',
          surname: 'BRLiam',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [
          'broken-luggage.png',
          'liam-reimbursement.pdf',
          'broken-luggage2.png',
        ],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        idOnExternalPlatform: '1391648474915950598',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Liam,<br><br>There is a possiblity to be reimbursed for damages to one’s luggage. I will just need a confirmation # for your flight where the luggage was damaged.<br><br>Thanks,<br>Agent Nick</p>',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'customer.service@delta.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Agent',
          surname: 'Nick',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: ['broken-luggage.png'],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: true,
      },
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        idOnExternalPlatform: '1391648474915950598',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Delta,<br><br>My confirmation # is: 345987<br>Liam</p>',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Sat, July 24 12:02 PM (2 day ago)',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'DavisBRLiam342@sunsyst.com',
          loginUsername: 'DavisBRLiam342@sunsyst.com',
          firstName: 'Davis',
          surname: 'Briliam',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [
          'broken-luggage.png',
          'liam-reimbursement.pdf',
          'broken-luggage2.png',
        ],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: true,
      },
    ],
  },
  copilotEmail_139: {
    id: 'email_139',
    historyemail: false,
    channelId: 'email_139',
    originId: '139',
    idOnExternalPlatform: '139',
    type: 'email',
    externalPlatformId: 'email',
    realExternalPlatformId: 'email',
    name: 'Email test',
    externalPlatformAvatar: '',
    externalPlatformIcon: '',
    integrationBoxIdent: null,
    channelIntegrationId: null,
    hasReply: true,
    hasTreeStructure: true,
    hasPostAsPlaceholder: false,
    contentFormat: 'html',
    hasCustomerOnThirdParty: false,
    isPostWritable: false,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: true,
    hasAbilityToTag: false,
    ownerUserId: 0,
    hasPublishing: false,
    hasAbilityToSendFiles: true,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: false,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: '',
    isLiveChat: false,
    hasAbilityToChangeRecipient: true,
    hasMultipleRecipient: true,
    hasCcAndBcc: true,
    hasVisibleTitle: true,
    hasEditableTitle: true,
    hasVisibleRecipients: true,
    hasAbilityToForwardMessage: true,
    canSaveResponse: false,
    skill: 'KK-Email-Queue',
    messages: [
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1364919321047166982',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Delta Customer Service,</p><p>I am writing to express my frustration with my recent flight from Salt Lake City to Chicago. First, the flight was three hours late which ruined my schedule for the day. Next, when I arrived home in Chicago, my luggage had disappeared and nobody could find it. It never showed up at baggage claim. Finally, when it showed up three days later on my porch, the wheel was completely broken and there were deep scratches and dents all over the surface (attached). As a loyal customer of your airline, I expected better care and handling of my belongings and would like to know the process for replacing my luggage.</p><p>Thanks,<br />Liam Davis</p>',
          },
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110003',
          emailAddress: 'DavisBRLiam342@sunsyst.com',
          loginUsername: 'DavisBRLiam342@sunsyst.com',
          firstName: 'Davis',
          surname: 'BRLiam',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [
          'broken-luggage.png',
          'liam-reimbursement.pdf',
          'broken-luggage2.png',
        ],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
    ],
  },
  historyemail_139: {
    id: 'email_139',
    historyemail: true,
    channelId: 'email_139',
    originId: '139',
    idOnExternalPlatform: '139',
    type: 'email',
    externalPlatformId: 'email',
    realExternalPlatformId: 'email',
    name: 'Email test',
    externalPlatformAvatar: '',
    externalPlatformIcon: '',
    integrationBoxIdent: null,
    channelIntegrationId: null,
    hasReply: true,
    hasTreeStructure: true,
    hasPostAsPlaceholder: false,
    contentFormat: 'html',
    hasCustomerOnThirdParty: false,
    isPostWritable: false,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: true,
    hasAbilityToTag: false,
    ownerUserId: 0,
    hasPublishing: false,
    hasAbilityToSendFiles: true,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: false,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: '',
    isLiveChat: false,
    hasAbilityToChangeRecipient: true,
    hasMultipleRecipient: true,
    hasCcAndBcc: true,
    hasVisibleTitle: true,
    hasEditableTitle: true,
    hasVisibleRecipients: true,
    hasAbilityToForwardMessage: true,
    canSaveResponse: false,
    skill: 'KK-Email-Queue',
    messages: [
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1364919321047166982',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Delta,<br><br>In my most recent flight I checked in my bags, and one of my suitcases came back damaged. I was reading the customer guidelines about luggage handling. It looks like it is possible to be reimbursed for the damage. I would like to be compensated to replace or repair my broken luggage.<br><br>Thanks,<br>Liam</p>',
          },
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110003',
          emailAddress: 'DavisBRLiam342@sunsyst.com',
          loginUsername: 'DavisBRLiam342@sunsyst.com',
          firstName: 'Davis',
          surname: 'BRLiam',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [
          'broken-luggage.png',
          'liam-reimbursement.pdf',
          'broken-luggage2.png',
        ],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        idOnExternalPlatform: '1391648474915950598',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Liam,<br><br>There is a possiblity to be reimbursed for damages to one’s luggage. I will just need a confirmation # for your flight where the luggage was damaged.<br><br>Thanks,<br>Agent Nick</p>',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'customer.service@delta.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Agent',
          surname: 'Nick',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: ['broken-luggage.png'],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: true,
      },
      {
        id: 'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        idOnExternalPlatform: '1391648474915950598',
        threadId:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '<p>Hi Delta,<br><br>My confirmation # is: 345987<br>Liam</p>',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Sat, July 24 12:02 PM (2 day ago)',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'DavisBRLiam342@sunsyst.com',
          loginUsername: 'DavisBRLiam342@sunsyst.com',
          firstName: 'Davis',
          surname: 'Briliam',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [
          'broken-luggage.png',
          'liam-reimbursement.pdf',
          'broken-luggage2.png',
        ],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'email_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: true,
      },
    ],
  },
  fb_dm_163746291068261: {
    id: 'fb_dm_163746291068261',
    channelId: 'fb_dm_163746291068261',
    originId: '163746291068261',
    idOnExternalPlatform: '163746291068261',
    type: 'fb',
    externalPlatformId: 'fb',
    realExternalPlatformId: 'fb',
    name: 'Holahola (Messaging)',
    externalPlatformAvatar:
      'https://brand-embassy-channel-facebook-qa.s3.eu-west-1.amazonaws.com/163746291068261_c8d59245-75b8-478e-8bdd-d299766f4378.png',
    externalPlatformIcon: 'facebook-dm',
    integrationBoxIdent: '33253fda-834b-455e-9479-1e34bd058f4f',
    channelIntegrationId: '33253fda-834b-455e-9479-1e34bd058f4f',
    hasReply: true,
    hasTreeStructure: false,
    hasPostAsPlaceholder: true,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: true,
    hasAbilityToLike: true,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: true,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1429,
    hasPublishing: false,
    hasAbilityToSendFiles: true,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: 'Chimerical',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-Facebook-Queue',
    messages: [
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1364919321047166982',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Whether understated monochrome, or bright and bold is your thing. there’s a world of options in the Vans Customs Shop.Be the designer at vans.com/customs',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-02-25T12:44:59+0000',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110003',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: '@Vans',
          firstName: 'Vans',
          surname: 'Vans',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391648474915950598',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Me too. I’ve been soooo frustrated with Model X. These clowns are going to expect us to upgrade to get a fix.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T06:57:06+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Errol Sloan',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391649967689723911',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I don’t know what you’re talking about.  I got my Model X four months ago and it’s been rock-solid.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:03:02+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Jarrod Spence',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391650112724635648',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I gave up on Chimerical products.  I moved to Bellerophon last year and haven’t looked back!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:03:37+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Sue Stein',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'f3bf58ef-b7ad-4372-9ccd-060a0d618ab5',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391650229330481155',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I’ve been using X for couple years with great results.  I’ll definitely be looking into Model Y!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:04:05+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Dawn Finley',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '143b251d-c634-47f0-86ba-fa0aeb8da497',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '50% faster and 30% cooler probably means 1000% more expensive.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:17:44+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Fidel Davila',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '1952f39c-ec9f-4870-8bb4-ba5b1fc2638c',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '50% faster probably means it’s going to need to be reset 50% more often.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:18:05+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Ronda Estes',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '9f8d7d03-ed6e-4438-a890-e3095e07fb94',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'If those performance improvements are remotely accurate, I’m interested!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:21:49+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Reva Forbes',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'd2cc1b2a-037d-405a-b6aa-7d1255f53556',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I wish you would fix Widget Model X because I have to reset it at least once a month.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:29:39+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'agent',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'ace37ffe-ec99-441d-ac68-1ae45e2f0abf',
        isOwn: true,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I wish you would fix Widget Model X because I have to reset it at least once a month.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:29:39+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'agent',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'ace37ffe-ec99-441d-ac68-1ae45e2f0123',
        isOwn: true,
      },
    ],
  },
  ig_3291273705: {
    id: 'ig_3291273705',
    channelId: 'ig_3291273705',
    originId: '3291273705',
    idOnExternalPlatform: '3291273705',
    type: 'ind',
    externalPlatformId: 'ind',
    realExternalPlatformId: 'ig',
    name: 'beplayground',
    externalPlatformAvatar:
      'https://scontent.xx.fbcdn.net/v/t51.2885-15/20479104_321290608322654_2219397480892596224_a.jpg?_nc_cat=0&oh=5829a97de20dcf575c7cce3a7dc3118c&oe=5C310DCA',
    externalPlatformIcon: 'instagram',
    integrationBoxIdent: '1f9438ac-d496-4c9d-85bb-95fb13e51b60',
    channelIntegrationId: '1f9438ac-d496-4c9d-85bb-95fb13e51b60',
    hasReply: true,
    hasTreeStructure: true,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: false,
    hasAbilityToQuoteMessage: true,
    hasAbilityToLike: true,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1130,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: false,
    replyPrefixMentionTemplate: '@{userNickname}',
    nicknameOnExternalPlatform: 'IKEA USA',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-Instagram-Queue',
    originalTweetContent:
      'Cozy up with HOSTKVALL,our new autmn-inspired collection designed to help you welcome all the joys of the season into your home!',
    customerReplyContent:
      'Still waiting on my 2021 catalog.What’s taking so long?',
    otherReplies: [
      {
        name: 'Errol Sloan',
        tweet:
          'Me too.  I’ve been soooo frustrated with Model X.  These clowns are going to expect us to upgrade to get a fix.',
      },
      {
        name: 'Jarrod Spence',
        tweet:
          'I don’t know what you’re talking about.  I got my Model X four months ago and it’s been rock-solid.',
      },
      {
        name: 'Sue Stein',
        tweet:
          'I gave up on Chimerical products.  I moved to Bellerophon last year and haven’t looked back!',
      },
      {
        name: 'Dawn Finley',
        tweet:
          'I’ve been using X for couple years with great results.  I’ll definitely be looking into Model Y!',
      },
      {
        name: 'Fidel Davila',
        tweet: '50% faster and 30% cooler probably means 1000% more expensive.',
      },
      {
        name: 'Ronda Estes',
        tweet:
          '50% faster probably means it’s going to need to be reset 50% more often.',
      },
      {
        name: 'Reva Forbes',
        tweet:
          'If those performance improvements are remotely accurate, I’m interested!',
      },
    ],
    agentReply: [],
    messages: [
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1364919321047166982',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Cozy up with HOSTKVALL,our new autmn-inspired collection designed to help you welcome all the joys of the season into your home!',
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-02-25T12:44:59+0000',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110003',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: '@Ikea',
          firstName: 'IKEA USA',
          surname: 'IKEA USA',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391648474915950598',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'Me too. I’ve been soooo frustrated with Model X. These clowns are going to expect us to upgrade to get a fix.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T06:57:06+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Errol Sloan',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'fed9399d-655e-4e8d-b397-4ab808360447',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391649967689723911',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I don’t know what you’re talking about.  I got my Model X four months ago and it’s been rock-solid.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:03:02+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Jarrod Spence',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391650112724635648',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I gave up on Chimerical products.  I moved to Bellerophon last year and haven’t looked back!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:03:37+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Sue Stein',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'f3bf58ef-b7ad-4372-9ccd-060a0d618ab5',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391650229330481155',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I’ve been using X for couple years with great results.  I’ll definitely be looking into Model Y!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:04:05+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Dawn Finley',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '143b251d-c634-47f0-86ba-fa0aeb8da497',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '50% faster and 30% cooler probably means 1000% more expensive.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:17:44+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Fidel Davila',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '1952f39c-ec9f-4870-8bb4-ba5b1fc2638c',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: '50% faster probably means it’s going to need to be reset 50% more often.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:18:05+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Ronda Estes',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '9f8d7d03-ed6e-4438-a890-e3095e07fb94',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'If those performance improvements are remotely accurate, I’m interested!',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:21:49+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'Reva Forbes',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'd2cc1b2a-037d-405a-b6aa-7d1255f53556',
        isOwn: false,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I wish you would fix Widget Model X because I have to reset it at least once a month.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:29:39+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'agent',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'ace37ffe-ec99-441d-ac68-1ae45e2f0abf',
        isOwn: true,
      },
      {
        id: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        idOnExternalPlatform: '1391653665719549954',
        threadId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: 'I wish you would fix Widget Model X because I have to reset it at least once a month.',
          },
        },
        reactionStatistics: {
          likes: 1350,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: '2021-05-10T07:29:39+0000',
        direction: 'string',
        authorUser: {
          id: 24612,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110002',
          emailAddress: 'mahesh.chandiramani@do31.com',
          loginUsername: 'agent04.sfdcinternalgbu@do0031.com',
          firstName: 'agent',
          surname: 'agent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'positive',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: 'ace37ffe-ec99-441d-ac68-1ae45e2f0123',
        isOwn: true,
      },
    ],
  },
  ind_17841403171171409: {
    id: 'ind_17841403171171409',
    channelId: 'ind_17841403171171409',
    originId: '17841403171171409',
    idOnExternalPlatform: '17841403171171409',
    type: 'ind',
    externalPlatformId: 'ind',
    realExternalPlatformId: 'ig',
    name: 'BE Playground',
    externalPlatformAvatar:
      'https://brand-embassy-channel-instagram-qa.s3.eu-west-1.amazonaws.com/17841403171171409_bec6c121-8d15-4b3a-ad0d-f9fdac2fbcaf.jpeg',
    externalPlatformIcon: 'instagram',
    integrationBoxIdent: '1f9438ac-d496-4c9d-85bb-95fb13e51b60',
    channelIntegrationId: '1f9438ac-d496-4c9d-85bb-95fb13e51b60',
    hasReply: true,
    hasTreeStructure: true,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1130,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '@{userNickname}',
    nicknameOnExternalPlatform: 'beplayground',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
  },
  li_14034105: {
    id: 'li_14034105',
    channelId: 'li_14034105',
    originId: '14034105',
    idOnExternalPlatform: '14034105',
    type: 'ind',
    externalPlatformId: 'ind',
    realExternalPlatformId: 'li',
    name: 'BE QA Test Page',
    externalPlatformAvatar:
      'https://brand-embassy-channel-linked-in-qa.s3.eu-west-1.amazonaws.com/14034105_0158e047-8659-47a5-8301-60738eef2f54.png',
    externalPlatformIcon: 'linkedin',
    integrationBoxIdent: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    channelIntegrationId: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    hasReply: false,
    hasTreeStructure: false,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1429,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: 'be-qa-test-page',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
  },
  sms_14034105: {
    id: 'sms_14034105',
    channelId: 'sms_14034105',
    originId: '14034105',
    idOnExternalPlatform: '14034105',
    type: 'ind',
    externalPlatformId: 'ind',
    realExternalPlatformId: 'sms',
    name: 'BE QA Test Page',
    externalPlatformAvatar:
      'https://brand-embassy-channel-linked-in-qa.s3.eu-west-1.amazonaws.com/14034105_0158e047-8659-47a5-8301-60738eef2f54.png',
    externalPlatformIcon: 'linkedin',
    integrationBoxIdent: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    channelIntegrationId: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    hasReply: false,
    hasTreeStructure: false,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: true,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1429,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: 'be-qa-test-page',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-SMS-Queue',
    messages: [
      {
        id: 'sms_14034105',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'sms_14034105',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: `I would like some help locating some lugguage that you lost yesterday. I've been trying to call but the wait time is super long`,
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'clarkkent@do31.com',
          loginUsername: '@Clark',
          firstName: 'Clark',
          surname: 'Kent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'chat_1359751597379620865_b81029d6-c53t-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
    ],
  },
  videocall: {
    id: 'videoCall_140341056',
    channelId: 'videoCall_140341056',
    originId: '140341056',
    idOnExternalPlatform: '140341056',
    type: 'VideoCall',
    externalPlatformId: 'VideoCall',
    realExternalPlatformId: 'VideoCall',
    name: 'VideoCall',
    externalPlatformAvatar:
      'https://brand-embassy-channel-linked-in-qa.s3.eu-west-1.amazonaws.com/14034105_0158e047-8659-47a5-8301-60738eef2f54.png',
    externalPlatformIcon: '####',
    integrationBoxIdent: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    channelIntegrationId: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    hasReply: false,
    hasTreeStructure: false,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1429,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: 'be-qa-test-page',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    skill: 'KK-Video-Queue',
    messages: [
      {
        id: 'videoCall_14034105',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'videoCall_14034105',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: `I would like some help locating some lugguage that you lost yesterday. I've been trying to call but the wait time is super long`,
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'clarkkent@do31.com',
          loginUsername: '@Clark',
          firstName: 'Clark',
          surname: 'Kent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'videoCall_1359751597379620865_b81029d6-c53t-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
    ],
  },
  reimbursementClaim: {
    id: 'reimbursementClaim',
    channelId: 'reimbursementClaim',
    originId: 'reimbursementClaim',
    idOnExternalPlatform: 'reimbursementClaim',
    type: 'ind',
    externalPlatformId: 'ind',
    realExternalPlatformId: 'reimbursementClaim',
    name: 'BE QA Test Page',
    externalPlatformAvatar:
      'https://brand-embassy-channel-linked-in-qa.s3.eu-west-1.amazonaws.com/14034105_0158e047-8659-47a5-8301-60738eef2f54.png',
    externalPlatformIcon: 'reimbursementClaim',
    integrationBoxIdent: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    channelIntegrationId: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    hasReply: false,
    hasTreeStructure: false,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1429,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: 'be-qa-test-page',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
    messages: [
      {
        id: 'reimbursementClaim_14034105',
        idOnExternalPlatform: '13649193210471634682',
        threadId: 'reimbursementClaim_14034105',
        messageContent: {
          type: 'TEXT',
          payload: {
            text: `I would like some help locating some lugguage that you lost yesterday. I've been trying to call but the wait time is super long`,
          },
        },
        reactionStatistics: {
          likes: 1250,
          shares: 764,
          isLikedByChannel: false,
          isSharedByChannel: false,
        },
        createdAt: 'Mon, July 26 2:02 PM (1 day ago)',
        direction: 'string',
        authorUser: {
          id: 24254,
          incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
          emailAddress: 'clarkkent@do31.com',
          loginUsername: '@Clark',
          firstName: 'Clark',
          surname: 'Kent',
          isBotUser: false,
          isSurveyUser: false,
        },
        authorEndUserIdentity: null,
        isDeletedOnExternalPlatform: false,
        isHiddenOnExternalPlatform: false,
        isRead: false,
        attachments: [],
        tags: [
          {
            id: 123,
            title: '',
            color: '',
          },
        ],
        sentiment: 'neutral',
        contentRemoved: null,
        authorNameRemoved: null,
        replyToMessage:
          'reimbursementClaim_1359751597379620865_b81029d6-c53t-406b-8bef-314d1eabbb49',
        readAt: {
          date: '2021-05-10 07:03:02.000000',
          timezone_type: 1,
          timezone: '+00:00',
        },
        messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
        isOwn: true,
      },
    ],
  },
  defaultDummy: {
    id: '####_14034105',
    channelId: '####_14034105',
    originId: '14034105',
    idOnExternalPlatform: '14034105',
    type: 'ind',
    externalPlatformId: 'ind',
    realExternalPlatformId: '####',
    name: 'BE QA Test Page',
    externalPlatformAvatar:
      'https://brand-embassy-channel-linked-in-qa.s3.eu-west-1.amazonaws.com/14034105_0158e047-8659-47a5-8301-60738eef2f54.png',
    externalPlatformIcon: '####',
    integrationBoxIdent: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    channelIntegrationId: '09779908-bdd2-4055-a82a-ef23cb52f64d',
    hasReply: false,
    hasTreeStructure: false,
    hasPostAsPlaceholder: false,
    contentFormat: 'plain',
    hasCustomerOnThirdParty: false,
    isPostWritable: true,
    hasAbilityToQuoteMessage: false,
    hasAbilityToLike: false,
    shouldBeNotifiedAboutReassign: false,
    isPrivate: false,
    isHidden: false,
    wysiwygEnabled: false,
    hasAbilityToTag: false,
    ownerUserId: 1429,
    hasPublishing: false,
    hasAbilityToSendFiles: false,
    hasOutboundFlow: false,
    hasAbilityToShare: false,
    hasAbilityToDelete: false,
    hasAbilityToHide: false,
    isVisibleInSettingsChannels: true,
    replyPrefixMentionTemplate: '',
    nicknameOnExternalPlatform: 'be-qa-test-page',
    isLiveChat: false,
    hasAbilityToChangeRecipient: false,
    hasMultipleRecipient: false,
    hasCcAndBcc: false,
    hasVisibleTitle: false,
    hasEditableTitle: false,
    hasVisibleRecipients: false,
    hasAbilityToForwardMessage: false,
    canSaveResponse: false,
  },
};

/**
 *
 * @param channel - type of the channel
 * @returns Mock data for the particular channel
 * @example getInteractionData('sms');
 */
export const getInteractionData = (
  channel?: string,
  copilotAssist?: string
) => {
  switch (channel) {
    case DigitalChannelType.TWITTER:
      return formatData(data.tw_1064553226341621761);
    case DigitalChannelType.CHAT:
      return formatData(data.chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d);
    case DigitalChannelType.SMS:
      return formatData(data.sms_14034105);
    case DigitalChannelType.FACEBOOK:
      return formatData(data.fb_dm_163746291068261);
    case DigitalChannelType.EMAIL:
      return copilotAssist === 'Yes'
        ? formatData(data.copilotEmail_139)
        : formatData(data.email_139);
    case DigitalChannelType.HISTORYEMAIL:
      return formatData(data.historyemail_139);
    case DigitalChannelType.INSTAGRAM:
      return formatData(data.ig_3291273705);
    case DigitalChannelType.LINKEDIN:
      return data.li_14034105;
    case DigitalChannelType.WHATSAPP:
      return data.ig_3291273705;
    case DigitalChannelType.VIDEOCALL:
      return formatData(data.videocall);
    case 'reimbursementClaim':
      return formatData(data.reimbursementClaim);
    default:
      return data.defaultDummy;
  }
};

/**
 * Function used to formatData
 * @param data - any
 * @example - formatData(data)
 * @returns
 */
const formatData = (data: any) => ({
  id: data.id,
  channelID: data.channelId,
  realExternalPlatformId: data.realExternalPlatformId,
  name: data.name,
  skill: data.skill,
  hasAbilityToQuoteMessage: data.hasAbilityToQuoteMessage,
  hasAbilityToLike: data.hasAbilityToLike,
  hasAbilityToShare: data.hasAbilityToShare,
  isPrivate: data.isPrivate,
  hasAbilityToSendFiles: data.hasAbilityToSendFiles,
  nicknameOnExternalPlatform: data.nicknameOnExternalPlatform,
  originalTweetContent: data.messages.length ? data.messages[0] : {},
  agentReply: data.messages.length
    ? data.messages.filter((msg: any) => msg.isOwn)
    : [],
  otherReplies: data.messages.length
    ? data.messages.filter((msg: any, i: number) => !msg.isOwn && i !== 0)
    : [],
  isHistoryEmailContent: data?.historyemail,
});

/**
 * Function to format messages
 * @param message - any
 * @example
 * @returns
 */
const formatMessage = (message: any) => ({
  messageId: message.messageId,
  messageContent: message.messageContent.payload.text,
  createdAt: message.createdAt,
  receivedAt: message.receivedAt,
});

export const botTranscriptData = [
  {
    messageFrom: 'customer',
    message: ['Hi I am facing issue with internet'],
  },
  {
    messageFrom: 'bot',
    message: ['A specialist will be with you shortly'],
  },
];

export const customerReplies = [
  {
    type: 'bot',
    negativeMsg: '',
    postiveMsg: '',
    intermediateMsg: '',
    card: '',
  },

  {
    type: 'bot',
    negativeMsg: 'A specialist will be with you shortly',
    postiveMsg: 'A specialist will be with you shortly',
    intermediateMsg: 'A specialist will be with you shortly',
    card: '',
  },

  {
    from: {
      type: 'customer',
    },
    msg: {
      message: "I need my luggage bag. It's been 4 hours!",
    },
  },
  {
    from: {
      type: 'customer',
    },
    msg: {
      message: 'will you be able to help me finally?',
    },
  },
  // ,{
  //    "from":{
  //       "type":"user1"
  //    },
  //    "msg":{
  //       "message": "Planning to go to a movie. Wanna come?"
  //       }
  // }
];
